import { useState, useEffect } from 'react';
import { useMMAuth } from '@machinemetrics/mm-react-tools';

// Returns { user: { email, name, mmCompanyId, role }, loading }
// In dev mode (no MMProvider), returns a root mock user so all UI is enabled locally.
export function useCurrentUser() {
  const [user, setUser]     = useState(null);
  const [loading, setLoading] = useState(true);

  const auth        = useMMAuth(); // undefined when no MMProvider (dev mode)
  const accessToken = auth?.accessToken ?? null;

  useEffect(() => {
    if (!accessToken) {
      setUser({ email: 'dev@machinemetrics.com', name: 'Dev User', mmCompanyId: 'dev', role: 'root' });
      setLoading(false);
      return;
    }
    const { request, urls } = auth;
    request(`${urls.apiUrl}/accounts/current`)
      .then(data => setUser({
        email:       data.email,
        name:        data.name,
        mmCompanyId: data.company?.id ?? null,
        role:        data.role ?? 'user',
      }))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [accessToken]); // eslint-disable-line react-hooks/exhaustive-deps

  return { user, loading };
}
